export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false
  }

  const maxTouchPoints = (navigator as Navigator & { maxTouchPoints?: number }).maxTouchPoints ?? 0

  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && maxTouchPoints > 1)
}

let switchInput: HTMLInputElement | null = null

function getSwitchInput(): HTMLInputElement | null {
  if (typeof document === 'undefined') {
    return null
  }

  if (switchInput?.isConnected) {
    return switchInput
  }

  const input = document.createElement('input')
  input.type = 'checkbox'
  input.setAttribute('switch', '')
  input.setAttribute('aria-hidden', 'true')
  input.tabIndex = -1
  input.style.cssText =
    'position:fixed;left:0;top:0;width:1px;height:1px;margin:0;opacity:0;pointer-events:none;border:0;padding:0;'

  document.documentElement.appendChild(input)
  switchInput = input
  return input
}

export function triggerIosSwitchHaptic(): void {
  if (!isIosDevice()) {
    return
  }

  try {
    getSwitchInput()?.click()
  } catch {
    // ignore
  }
}
